import {
  DOWNLOAD_TYPES,
  FILE_STATUSES,
  MESSAGE_CHANNEL,
  MESSAGE_STATUSES,
  MESSAGE_TYPES,
} from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import { getDateData } from "../../providers";
import type {
  MessageFile,
  ReplyMessage,
  TextDataForMessage,
} from "../../types";

const { getRandomUuid } = helpers.utilities;

type Params = {
  authorId: string;
  message: TextDataForMessage;
  replyMessage: ReplyMessage;
  file: File;
};

type Return = MessageFile;

export const createMessageFile = ({
  authorId,
  message: { text, entities },
  replyMessage,
  file,
}: Params): Return => ({
  id: "",
  traceId: getRandomUuid("trace_id"),
  authorId,
  date: getDateData(),
  editDate: "",
  type: MESSAGE_TYPES.FILE,
  status: MESSAGE_STATUSES.SEND,
  channel: MESSAGE_CHANNEL.INPUT,

  replyMessage,

  content: {
    text: text.trim(),
    entities,
    link: "",
    file: {
      id: "", // TODO генерация id
      name: file.name,
      type: file.type,
      status: FILE_STATUSES.ON_CHECK,
      data: "",
      mime: "",
      downloading: DOWNLOAD_TYPES.DOWNLOADING_ALLOWED,
    },
  },
});
